import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  approveExperience,
  rejectExperience,
  editExperience,
} from "@/services/adminApi";

export function useApproveExperience() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, note }: { id: string; note?: string }) =>
      approveExperience(id, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "moderation"] });
    },
  });
}

export function useRejectExperience() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      reason,
      note,
    }: {
      id: string;
      reason: string;
      note?: string;
    }) => rejectExperience(id, reason, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "moderation"] });
    },
  });
}

export function useEditExperience() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      sanitizedContext,
      note,
    }: {
      id: string;
      sanitizedContext: string;
      note?: string;
    }) => editExperience(id, sanitizedContext, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "moderation"] });
    },
  });
}
